import type { HTMLAttributes, ReactNode } from "react";

import { cn } from "@/lib/utils";

interface SectionCardProps extends Omit<HTMLAttributes<HTMLDivElement>, "title"> {
  title?: ReactNode;
  description?: ReactNode;
  /** Slot no canto direito do header (acoes/filtros). */
  actions?: ReactNode;
  tone?: "default" | "muted";
  /** Use `false` para remover o padding padrao (util quando o conteudo
   *  e uma tabela full-bleed). */
  padded?: boolean;
}

export function SectionCard({
  title,
  description,
  actions,
  tone = "default",
  padded = true,
  className,
  children,
  ...props
}: SectionCardProps) {
  return (
    <section
      className={cn(
        "shadow-card flex flex-col gap-5 rounded-2xl border border-line",
        tone === "muted" ? "bg-surface-muted" : "bg-surface",
        padded && "p-6",
        className,
      )}
      {...props}
    >
      {title || description || actions ? (
        <header className="flex flex-wrap items-start justify-between gap-3">
          <div className="flex min-w-0 flex-col gap-1">
            {title ? (
              <h2 className="text-[15px] font-semibold tracking-tight text-ink-950">
                {title}
              </h2>
            ) : null}
            {description ? (
              <p className="text-xs text-ink-500">{description}</p>
            ) : null}
          </div>
          {actions ? (
            <div className="flex flex-wrap items-center gap-2">{actions}</div>
          ) : null}
        </header>
      ) : null}
      {children}
    </section>
  );
}
